<template>
  <v-text-field
    dense
    outlined
    filled
    readonly
    disabled
    hide-details
  >
    <template
      v-if="mostrarIcones"
      v-slot:prepend
    >
      <icons
        :is-configurar-celula-dialog-open="isConfigurarCelulaDialogOpen"
        :is-deletar-componente-dialog-open="isDeletarComponenteDialogOpen"
        :pode-deletar="false"
        @update:is-configurar-celula-dialog-open="v => $emit('update:is-configurar-celula-dialog-open', v)"
        @update:is-deletar-componente-dialog-open="v => $emit('update:is-deletar-componente-dialog-open', v)"
      />
    </template>
  </v-text-field>
</template>

<script>
import ComponenteBase from './ComponenteBase.vue'
import Icons from './Icons.vue'

export default {
  components: {
    Icons,
  },

  extends: ComponenteBase,
}
</script>
